import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './SerialNumbers.types'

@Injectable({ providedIn: 'root' })
export class SerialNumbers_create_audit_taskService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { isAbort: boolean, entity: { warehouseId: number, locationId?: number, shippingContainerId?: number, licensePlateId?: number }, reasonCodeId?: number, expectedSerialNumberCodes?: string[], scannedSerialNumberCodes?: string[], startDateTime?: string }): Promise<{ reasons?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.isAbort)) {
      missingRequiredInParams.push('\'isAbort\'');
    }
    if (isNil(inParams.entity)) {
      missingRequiredInParams.push('\'entity\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/functions/create_audit_task`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

